import { GET_USER_ME, userService } from '@/api';
import { ErrorHttpResponse } from '@/interfaces';
import { useQuery } from '@tanstack/react-query';
import { signOut, useSession } from 'next-auth/react';
import * as React from 'react';

export const useUser = () => {
	const { data: session } = useSession();
	const { data: userMe, error } = useQuery({
		queryKey: [GET_USER_ME],
		queryFn: () => userService.getUserMe(),
		enabled: !!session,
		staleTime: 1000 * 60 * 5,
		gcTime: 1000 * 60 * 30,
		retry: (failureCount, error) => {
			// Do not retry if it is a 401 error
			if ((error as any)?.status === 401) return false;
			// Retry other times according to default settings
			return failureCount < 3;
		},
	});

	React.useEffect(() => {
		if ((error as ErrorHttpResponse | null)?.status === 401 && !!session) {
			signOutFunction();
		}
	}, [error, session]);

	const signOutFunction = async () => {
		const type = session?.user.user.role;
		if (type === 'lawyer') {
			await signOut({
				redirect: false,
				basePath: '/api/auth-lawyer',
			} as any);
		} else {
			await signOut({
				redirect: false,
			});
		}
	};

	return {
		user: userMe?.data,
		signOut: signOutFunction,
	};
};
